import type { HoverIdleEffectUnlockState, HoverIdleGridTier } from "../types";
import { compareHuge, type HugeNumber } from "@/shared/numbers";

export const HOV_GRID_INCREASE_1_UNLOCK_CURRENT_LOOP_HOV_THRESHOLD = 500;
export const HOV_GRID_INCREASE_2_UNLOCK_CURRENT_LOOP_HOV_THRESHOLD = 5_000_000_000;

export const HOV_GRID_INCREASE_1_TIER: HoverIdleGridTier = 4;
export const HOV_GRID_INCREASE_2_TIER: HoverIdleGridTier = 9;

export function createDefaultHoverIdleEffectUnlockState(): HoverIdleEffectUnlockState {
  return {
    hov: {
      gridIncrease1: false,
      gridIncrease2: false,
    },
  };
}

export function resolveHoverIdleEffectUnlockState(options: {
  readonly currentLoopHovEarned: HugeNumber;
  readonly existing?: Partial<HoverIdleEffectUnlockState>;
}): HoverIdleEffectUnlockState {
  const { currentLoopHovEarned, existing } = options;

  return {
    hov: {
      gridIncrease1:
        existing?.hov?.gridIncrease1 === true ||
        compareHuge(
          currentLoopHovEarned,
          HOV_GRID_INCREASE_1_UNLOCK_CURRENT_LOOP_HOV_THRESHOLD,
        ) >= 0,
      gridIncrease2:
        existing?.hov?.gridIncrease2 === true ||
        compareHuge(
          currentLoopHovEarned,
          HOV_GRID_INCREASE_2_UNLOCK_CURRENT_LOOP_HOV_THRESHOLD,
        ) >= 0,
    },
  };
}

export interface HoverIdleEffectApplyTarget {
  readonly setHovGridTier: (tier: HoverIdleGridTier) => void;
}

export interface ApplyHoverIdleEffectUnlocksOptions {
  // Suppresses applying the second grid increase (tier 9) so the effective max
  // grid tier stays at HOV_GRID_INCREASE_1_TIER. Used while the Split Wall is
  // active; the unlock latch itself is untouched.
  readonly suppressSecondGridIncrease?: boolean;
}

export function applyHoverIdleEffectUnlocks(
  state: HoverIdleEffectUnlockState,
  target: HoverIdleEffectApplyTarget,
  options: ApplyHoverIdleEffectUnlocksOptions = {},
): void {
  if (state.hov.gridIncrease1) {
    target.setHovGridTier(HOV_GRID_INCREASE_1_TIER);
  }
  if (state.hov.gridIncrease2 && options.suppressSecondGridIncrease !== true) {
    target.setHovGridTier(HOV_GRID_INCREASE_2_TIER);
  }
}
